'use strict';

var angular = require('angular');
var XtFormConfig = function XtFormConfig() {
  var self = this,
    _errors = {
      minlength: 'Needs to be at least {{ngMinlength}} characters long',
      maxlength: 'Can be no longer than {{ngMaxlength}} characters long',
      required: 'This field is required',
      number: 'Must be a number',
      min: 'Must be at least {{min}}',
      max: 'Must be no greater than {{max}}',
      email: 'Must be a valid E-mail address',
      pattern: 'Illegal value',
      url: 'Must be a valid URL',
      date: 'Must be a valid date',
      datetimelocal: 'Must be a valid date',
      time: 'Must be a valid time',
      week: 'Must be a valid week',
      month: 'Must be a valid month',
      $$server: 'An error has occurred',
      constraintValidation: 'Wrong value',
      travelTimeMultipleOfSixty: 'Travel time should be multiples of 60'
    },
    _validationStrategyFn;
  angular.extend(self, {
    $validationStrategies: {
      invalid: function invalid(form) {
        return form.$invalid;
      },
      submitted: function submitted(form) {
        return form.$invalid && form.$submitted;
      },
      dirty: function dirty(form, ngModel) {
        return ngModel.$invalid && ngModel.$dirty;
      },
      dirtyOrSubmitted: function dirtyOrSubmitted(form, ngModel) {
        return ngModel.$invalid && (form.$submitted || ngModel.$dirty);
      },
      focusedAndDirtyOrSubmitted: function focusedAndDirtyOrSubmitted(form, ngModel) {
        return ngModel.$invalid && ngModel.$focused && (ngModel.$dirty || form.$submitted);
      },
      dirtyAndFocusedOrSubmitted: function dirtyAndFocusedOrSubmitted(form, ngModel) {
        return ngModel.$invalid && (form.$submitted || ngModel.$dirty && ngModel.$focused);
      }
    },
    addValidationStrategy: function addValidationStrategy(name, fn) {
      self.$validationStrategies[name] = fn;
    },
    setDefaultValidationStrategy: function setDefaultValidationStrategy(strategy) {
      if (!self.$validationStrategies[strategy]) {
        throw new Error('Could not find validation strategy by name: ' + strategy);
      }
      _validationStrategyFn = self.$validationStrategies[strategy];
    },
    setErrorMessages: function setErrorMessages(errors) {
      angular.extend(_errors, errors);
    }
  });
  this.$get = function () {
    return {
      getErrorMessages: function getErrorMessages() {
        return angular.copy(_errors);
      },
      getValidationStrategy: function getValidationStrategy(name) {
        if (!self.$validationStrategies[name]) {
          throw new Error('Could not find validation strategy by name: ' + name);
        }
        return self.$validationStrategies[name];
      },
      getDefaultValidationStrategy: function getDefaultValidationStrategy() {
        return _validationStrategyFn;
      }
    };
  };
  self.setDefaultValidationStrategy('dirtyOrSubmitted');
};
module.exports = XtFormConfig;